import { DialogMaster } from "#core/components/dialog/Dialog"
import { useApiSend } from "#hooks/useApiSend"
import { vacancyPost } from "#vacancy/services/api"
import { useVacanteReloadAll } from "#vacantes/redux/actions"
import { useCallback, useState } from "react"
import { VacancyForm, VacancyFormValidation } from "./VacancyForm"

export default function VacancyFormDialog({
	open,
	setOpen,
	defaultValues = {},
	promotion,
	refresh,
}) {
	const reload = useVacanteReloadAll()
	const [vacante, setVacante] = useState(defaultValues)
	const [disabled, setDisabled] = useState(false)

	const success = () => {
		setOpen(false)
		setVacante({})
		reload()
		if (typeof refresh === "function") refresh()
	}
	const end = () => {
		setDisabled(false)
	}
	const { fetch } = useApiSend(vacancyPost, { success, end })

	const handleSubmit = useCallback(() => {
		if (!VacancyFormValidation(vacante)) return
		setDisabled(true)
		fetch(vacante)
	}, [fetch, vacante])

	return (
		<DialogMaster
			{...{
				open,
				setOpen,
				maxWidth: "xl",
				handleSubmit,
				disabled,
				title: "Crear Vacante",
			}}
		>
			<VacancyForm {...{ vacante, setVacante, promotion }} />
		</DialogMaster>
	)
}
